module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"evaluation":"Zufriedenheits-Umfrage"},"en":{"evaluation":"Evaluation"}}')
  delete Component.options._Ctor
}
